<script setup lang="ts">
import * as Sentry from '@sentry/browser'
import { computed, onErrorCaptured, ref } from 'vue'

import useLayoutStore from '@/stores/layout'

import Default from '@/components/app/ErrorBoundary/ErrorDefault.vue'
import Status401 from '@/components/app/ErrorBoundary/ErrorStatus401.vue'
import ShopResetFailed from '@/components/app/ErrorBoundary/ErrorShopResetFailed.vue'

const layout = useLayoutStore()

const err = ref()
const instance = ref()
const info = ref()

onErrorCaptured((...args) => {
  ;[err.value, instance.value, info.value] = args
  console.error(args[0])
  Sentry.captureException(args[0])
})

const errorComponent = computed(() => {
  let output = Default

  switch (err.value?.response?.status) {
    case 401:
      output = Status401
      break
    case 'shop_reset_failed':
      output = ShopResetFailed
      break
  }

  return output
})

const classes = computed(() => [
  'error-layout',
  {
    'error-layout__border': layout.$state.format === 'card',
  },
])
</script>

<template>
  <slot v-if="err" name="error">
    <div class="pb-4">
      <div :class="classes">
        <component :is="errorComponent" />
      </div>
    </div>
  </slot>
  <slot v-else></slot>
</template>

<style scoped lang="postcss">
.error-layout {
  @apply flex flex-col items-center justify-center w-full h-full py-[20%] px-4;

  &__border {
    @apply bg-white border  border-theme-border-default;
  }
}
</style>
